<template>
  <div>
    <budget-alert-form ref="budgetAlertFormRef" />
  </div>
</template>

<script>
import BudgetAlertForm from '../../components/form'

export default {
  components: {
    BudgetAlertForm,
  },
  data () {
    return {}
  },
  methods: {
    validateFields () {
      const { $refs: { budgetAlertFormRef } } = this
      return budgetAlertFormRef.form.fc.validateFields()
    },
  },
}
</script>
